export default __webpack_public_path__ + "static/cover-7ae0586839f9d10e7cd74af17a48a11e.png";